export interface RedirectData {
  currentVertical?: string;
  nextVertical: string;
  verticalsWithoutRedirect?: string[];
  affclie?: string;
  journeyId: string;
  trade: string;
  allowTradeBasedRedirect?: boolean;
}

export const shouldRedirect = (data: RedirectData): boolean => {
  const {
    currentVertical,
    nextVertical,
    verticalsWithoutRedirect,
    allowTradeBasedRedirect,
  } = data;

  if (!allowTradeBasedRedirect || !currentVertical || !nextVertical)
    return false;
  if (currentVertical === nextVertical) return false;

  // Per-trade field: if the trade says "don't redirect for this vertical", respect it
  if (verticalsWithoutRedirect?.includes(currentVertical)) {
    return false;
  }

  return true;
};

export const getRedirectUrl = (data: RedirectData): string => {
  const { currentVertical, nextVertical, affclie, journeyId, trade } = data;
  const params = new URLSearchParams({
    ...(currentVertical ? { original_vertical: currentVertical } : {}),
    vertical: nextVertical,
    trade,
    journey_id: journeyId,
    ...(affclie ? { AFFCLIE: affclie } : {}),
  });

  return `/route_trade?${params.toString()}`;
};

export const redirect = (data: RedirectData): void => {
  if (!shouldRedirect(data)) return;

  const url = getRedirectUrl(data);

  window.location.assign(url);
};
